import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  Spacer,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import ReactDiffViewer from 'react-diff-viewer';

import { SaveBaseFieldsWipButton } from './SaveBaseFieldsWipButton';
import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { CommitCreditAgreementWipButton } from 'packages/creditAgreements/ui/creditAgreementWip/CommitCreditAgreementWipButton';
import { SettingStickyHeader } from 'packages/creditAgreements/ui/creditAgreementWip/SettingStickyHeader';

type Props = {
  oldValue: CreditAgreement.DataTapeField.LoanTapeSanitizeConfig | null;
  newValue: CreditAgreement.DataTapeField.LoanTapeSanitizeConfig | null;
  isCommitDisabled: boolean;
  isSaveDisabled: boolean;
  creditFacilityId: string;
  errors: string[];
  operationMode: CreditAgreement.OperationMode;
};
export const BaseFieldsWipStickyHeader = ({
  oldValue,
  newValue,
  isCommitDisabled,
  isSaveDisabled,
  errors,
  operationMode,
  creditFacilityId,
}: Props) => {
  const [isDiffOpen, setIsDiffOpen] = useState<boolean>(false);
  return (
    <SettingStickyHeader>
      <>
        {/* Chakra doesn't natively support flex-gap */}
        <Flex alignItems="center" style={{ gap: '32px' }}>
          <Button
            border="2px"
            padding="10px 24px"
            backgroundColor="white"
            variant="ouline"
            colorScheme="aurora"
            onClick={() => setIsDiffOpen(!isDiffOpen)}
          >
            <Text color={colors.aurora[400]} mr="16px">
              {isDiffOpen ? 'Hide Changes' : 'Show Changes'}
            </Text>
            <Icon icon={isDiffOpen ? 'chevron-up' : 'chevron-down'} />
          </Button>
          <Spacer />
          <SaveBaseFieldsWipButton
            creditFacilityId={creditFacilityId}
            config={newValue}
            isLoading={false}
            isDisabled={isSaveDisabled}
          />
          <CommitCreditAgreementWipButton
            isDisabled={isCommitDisabled}
            creditFacilityId={creditFacilityId}
            operationMode={operationMode}
            onCommitDone={() => {}}
          />
        </Flex>
        {errors.length > 0 && (
          <Alert status="warning" display="flex" w="fit-content">
            <AlertIcon />
            <AlertDescription>
              <Text>{errors.join(',')}</Text>
            </AlertDescription>
          </Alert>
        )}
        {isDiffOpen && (
          <Box mt="24px" maxHeight="70vh" overflowY="scroll">
            <ReactDiffViewer
              oldValue={JSON.stringify(oldValue, null, 4)}
              newValue={JSON.stringify(newValue, null, 4)}
              leftTitle="OriginalBaseFiels"
              rightTitle="WIP"
              splitView
            />
          </Box>
        )}
      </>
    </SettingStickyHeader>
  );
};
